import React, { useMemo, useState } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import config from '../utils/envLoader';

const containerStyle = {
    width: '100%',
    height: 'calc(100vh - 120px)',
    border: '1px solid #e2dfda',
    borderRadius: 8,
    overflow: 'hidden',
    background: '#fff',
    position: 'relative',
};

const DocumentationService = ({ type = 'comprehensive', path = 'docs/enterprise', title = 'Enterprise Documentation' }) => {
    const [loading, setLoading] = useState(true);

    // The docs endpoints serve a full site (MkDocs, or Swagger UI) that the
    // browser navigates into directly, so their own asset/subpage requests carry
    // the documentation cookie the backend sets on this entry request. We pass
    // the JWT once as a query param to bootstrap that cookie.
    const token = localStorage.getItem(config.tokenStorageKey);
    const src = useMemo(() => {
        const base = `${config.apiBaseUrl}/${path}/`;
        const params = new URLSearchParams();
        // Swagger UI is a single site and takes no `type`; the MkDocs sites are
        // selected by a `type` subfolder.
        if (type) {
            params.set('type', type);
        }
        if (token) {
            params.set('access_token', token);
        }
        const query = params.toString();
        return query ? `${base}?${query}` : base;
    }, [token, type, path]);

    if (!token) {
        return (
            <div style={{ ...containerStyle, padding: 24, overflow: 'auto' }}>
                <Alert variant="warning" className="mb-0">
                    You need to be signed in to view the enterprise documentation.
                </Alert>
            </div>
        );
    }

    return (
        <div style={containerStyle}>
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                    }}
                >
                    <Spinner animation="border" role="status" className="me-2" />
                    <span>Loading {title.toLowerCase()}…</span>
                </div>
            )}
            <iframe
                src={src}
                title={title}
                onLoad={() => setLoading(false)}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default DocumentationService;
